export const URL_BASE = '/panel'
import store from '../store'

export const IS_SISTEMA = () => store.getters['auth/userAccess'] === 0
export const IS_ADMIN = () => store.getters['auth/userAccess'] === 1
export const IS_SECRETARIA = () => store.getters['auth/userAccess'] === 2
export const IS_VEREADOR = () => store.getters['auth/userAccess'] === 3
export const IS_EXECUTIVO = () => store.getters['auth/userAccess'] === 4
export const IS_IMPRENSA = () => store.getters['auth/userAccess'] === 5

export function fromJson(model, object) {
    for (var name in model) {
        if (object.hasOwnProperty(name)) {
            model[name] = object[name]
        }
    }

    return model
}

export const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export function years(startYear, endYear = null) {

    var currentYear = endYear ? endYear : new Date().getFullYear() + 1, years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
        years.push(startYear++);
    }

    years.sort(function (a, b) {
        return b - a
    })
    return years;
}

export function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


export function getVarByText(string) {
    return string.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_');
}
